export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sporné sloupce"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resetovat"])}
}